module.exports = __webpack_public_path__ + "img/ar_my_set_grey.468a637e.svg";